// ------------------------------------------------------------------
function loadSwiperAssets(callback) {
  if (window.Swiper) {
    callback();
    return;
  }
  if (!document.getElementById('swiper-css')) {
    var link = document.createElement('link');
    link.id = 'swiper-css';
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    document.head.appendChild(link);
  }
  if (!document.getElementById('swiper-js')) {
    var script = document.createElement('script');
    script.id = 'swiper-js';
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    script.onload = callback;
    document.body.appendChild(script);
  } else {
    document.getElementById('swiper-js').addEventListener('load', callback);
  }
}

function initCertificationSwipers() {
  loadSwiperAssets(function () {
    document.querySelectorAll('.certification-swiper').forEach(function (el) {
      if (el.swiper) return; /* already initialized */
      new Swiper(el, {
        slidesPerView: 7,
        slidesPerGroup: 1,
        spaceBetween: 20,
        loop: true,
        autoplay: { delay: 2000, disableOnInteraction: false },
        speed: 800,
        breakpoints: {
          1200: { slidesPerView: 7 },
          992: { slidesPerView: 7 },
          768: { slidesPerView: 5 },
          650: { slidesPerView: 4 },
          535: { slidesPerView: 3 },
          312: { slidesPerView: 2 }
        }
      });
    });
  });
}
// ------------------------TMF LIFESTYLE GRID-----------------------
const initLifestyleSliderFinal = () => {
    const nextBtn = document.querySelectorAll('.next-ls');
    const prevBtn = document.querySelectorAll('.prev-ls');

    nextBtn.forEach(btn => {
        btn.onclick = function() {
            const wrapper = this.closest('.custom-lifestyle-relative-wrapper').querySelector('.custom-lifestyle-slider-wrapper');
            const cardWidth = wrapper.querySelector('.custom-lifestyle-col').offsetWidth;
            wrapper.scrollBy({ left: cardWidth, behavior: 'smooth' });
        };
    });

    prevBtn.forEach(btn => {
        btn.onclick = function() {
            const wrapper = this.closest('.custom-lifestyle-relative-wrapper').querySelector('.custom-lifestyle-slider-wrapper');
            const cardWidth = wrapper.querySelector('.custom-lifestyle-col').offsetWidth;
            wrapper.scrollBy({ left: -cardWidth, behavior: 'smooth' });
        };
    });
};

document.addEventListener('DOMContentLoaded', initLifestyleSliderFinal);
document.addEventListener('shopify:section:load', initLifestyleSliderFinal);

// ----------------------swiper js ----------------------------------------


document.addEventListener('DOMContentLoaded', function() {
  // Website load hone ke 1 second baad slider chalega taake TBT freeze na ho
  setTimeout(function() {
    
    // Destroy previous instance if any to prevent freeze on reload
    if(window.certificationSwiper){
      window.certificationSwiper.destroy(true, true);
    }

    window.certificationSwiper = new Swiper('.certification-swiper', {
      slidesPerView: 7,      // Desktop
      slidesPerGroup: 1,     // 1 logo per step
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 2000,         // 2 seconds per slide
        disableOnInteraction: false
      },
      speed: 800,            // smooth slide transition
      breakpoints: {
        1200: { slidesPerView: 7 },  
        992: { slidesPerView: 7 },
        768: { slidesPerView: 5 },
        650: { slidesPerView: 4 },
        535: { slidesPerView: 3 },
        312: { slidesPerView: 2 }
      }
    });

  }, 1000); // 1000 milliseconds = 1 Second delay
});

// ---------------------------------------------Home appliance-------------------------------------------------
// Home Appliance Carousal
document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.ha-carousel');
  const nextArrow = document.querySelector('.ha-carousel-arrow');
  const carouselItems = document.querySelectorAll('.ha-carousel-item');
  
  if (carouselItems.length === 0 || !carousel) return;

  let scrollIndex = 0;
  let itemWidth = carouselItems[0].offsetWidth + 16;

  // Function to scroll
  function scrollToIndex(index) {
    if (index < 0) scrollIndex = carouselItems.length - 1;
    else if (index >= carouselItems.length) scrollIndex = 0;
    else scrollIndex = index;

    carousel.scrollTo({
      left: scrollIndex * itemWidth,
      behavior: 'smooth'
    });
  }

// Arrow click with Smooth Reset Logic 
document.querySelectorAll('.ha-section').forEach((section) => {
  const nextArrow = section.querySelector('.ha-carousel-arrow');
  const carousel = section.querySelector('.ha-carousel');

  if (nextArrow && carousel) {
    nextArrow.addEventListener('click', () => {
      const firstItem = carousel.querySelector('.ha-carousel-item');
      if (!firstItem) return;

      const itemWidth = firstItem.offsetWidth + 16; // Item width + gap

      // Check if reached end: scrollLeft + visibleWidth >= totalScrollWidth
      if (carousel.scrollLeft + carousel.offsetWidth >= carousel.scrollWidth - 10) {
        // Reset to start (Loop back)
        carousel.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        // Scroll to next item
        carousel.scrollBy({ left: itemWidth, behavior: 'smooth' });
      }

      if (typeof resetAutoSlide === "function") resetAutoSlide();
    });
  }
});

  // 
  // let autoSlide = setInterval(() => {
  //   scrollToIndex(scrollIndex + 1);
  // }, 4000);

  // Reset auto-slide on click/swipe
  // function resetAutoSlide() {
  //   clearInterval(autoSlide);
  //   autoSlide = setInterval(() => {
  //     scrollToIndex(scrollIndex + 1);
  //   }, 4000);
  // }

  // Touch swipe logic
  // let startX = 0;
  // carousel.addEventListener('touchstart', e => startX = e.touches[0].clientX, {passive: true});
  // carousel.addEventListener('touchend', e => {
  //   const endX = e.changedTouches[0].clientX;
  //   if (startX - endX > 50) scrollToIndex(scrollIndex + 1); // swipe left
  //   else if (endX - startX > 50) scrollToIndex(scrollIndex - 1); // swipe right
  //   resetAutoSlide();
  // }, {passive: true});

  // Update itemWidth on window resize
  window.addEventListener('resize', () => {
    if (carouselItems.length > 0) {
      itemWidth = carouselItems[0].offsetWidth + 16;
    }
  });
});

// ---------------------------------feature strip js ------------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  const fsSlider = document.querySelector('.fs-slider');
  if (!fsSlider) return;

  // Only apply slider hover effect on mobile/tablet (optional)
  if (window.innerWidth < 992) {
    fsSlider.addEventListener('mouseenter', () => {
      fsSlider.style.animationPlayState = 'paused';
    });

    fsSlider.addEventListener('mouseleave', () => {
      fsSlider.style.animationPlayState = 'running';
    });
  }
});

//  ---------------------------------------trusted fan solution js-------------------------------------------- 

  document.addEventListener('DOMContentLoaded', function() {
    const fanSlider = document.getElementById('TrustedFanSlider');
    const fanNextBtn = document.getElementById('trustedFanNext');
    let isAutoScrolling = true;

    // Manual Click Navigation
    if(fanNextBtn) {
        fanNextBtn.addEventListener('click', () => {
            const firstCard = fanSlider.querySelector('.trusted-fan-card-col');
            const cardWidth = firstCard.offsetWidth;
            
            // Check if reached end, then reset to start
            if (fanSlider.scrollLeft + fanSlider.offsetWidth >= fanSlider.scrollWidth - 10) {
                fanSlider.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
                fanSlider.scrollBy({ left: cardWidth, behavior: 'smooth' });
            }
        });
    }

    // Auto Slide Logic (Every 4 seconds)
    // const startAutoSlide = () => {
    //     return setInterval(() => {
    //         if (isAutoScrolling) {
    //             if (fanSlider.scrollLeft + fanSlider.offsetWidth >= fanSlider.scrollWidth - 10) {
    //                 fanSlider.scrollTo({ left: 0, behavior: 'smooth' });
    //             } else {
    //                 const cardWidth = fanSlider.querySelector('.trusted-fan-card-col').offsetWidth;
    //                 fanSlider.scrollBy({ left: cardWidth, behavior: 'smooth' });
    //             }
    //         }
    //     }, 4000);
    // };

    // let fanAutoInterval = startAutoSlide();

    // Pause auto-slide when user interacts
    // fanSlider.addEventListener('touchstart', () => isAutoScrolling = false);
    // fanSlider.addEventListener('mousedown', () => isAutoScrolling = false);
    
    // Resume auto-slide after 10 seconds of inactivity
    // fanSlider.addEventListener('touchend', () => {
    //     setTimeout(() => isAutoScrolling = true, 10000);
    // });
  });

  // ------------------------------------section 3 js---------------------------------------------------------


  document.addEventListener('DOMContentLoaded', () => {
    const carousel = document.querySelector('.section3-carousel-row');
    const nextArrow = document.querySelector('.section3-carousel-arrow');
    const items = document.querySelectorAll('.section3-carousel-item');

    if (!carousel || items.length === 0) return;

    let scrollIndex = 0;
    
    function getScrollWidth() {
        return items[0].offsetWidth; 
    }

    function scrollToIndex(index) {
        if (index < 0) scrollIndex = items.length - 1;
        else if (index >= items.length) scrollIndex = 0;
        else scrollIndex = index;

        carousel.scrollTo({
            left: scrollIndex * getScrollWidth(),
            behavior: 'smooth'
        });
    }

    // Arrow Click
    if(nextArrow) {
        nextArrow.addEventListener('click', () => {
            scrollToIndex(scrollIndex + 1);
            resetAutoSlide();
        });
    }

    // Auto-slide Logic
    // let autoSlide = setInterval(() => {
    //     scrollToIndex(scrollIndex + 1);
    // }, 4000);

    // function resetAutoSlide() {
    //     clearInterval(autoSlide);
    //     autoSlide = setInterval(() => {
    //         scrollToIndex(scrollIndex + 1);
    //     }, 4000);
    // }

    // Swipe Support
    let startX = 0;
    carousel.addEventListener('touchstart', e => startX = e.touches[0].clientX);
    carousel.addEventListener('touchend', e => {
        const endX = e.changedTouches[0].clientX;
        if (startX - endX > 50) scrollToIndex(scrollIndex + 1); // Swipe Left
        else if (endX - startX > 50) scrollToIndex(scrollIndex - 1); // Swipe Right
        resetAutoSlide();
    });
});

  // ------------------------------------section 4 js---------------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {

  const carousel = document.querySelector('.section4-carousel');
  const nextArrow = document.querySelector('.section4-carousel-arrow');
  const carouselItems = document.querySelectorAll('.section4-carousel-item');

  if (!carousel || carouselItems.length === 0) return;

  let scrollIndex = 0;
  let gap = 16; // space between cards
  let itemWidth = carouselItems[0].offsetWidth + gap;

  // Function to scroll to a specific card
  function scrollToIndex(index) {
    if (index < 0) scrollIndex = carouselItems.length - 1;
    else if (index >= carouselItems.length) scrollIndex = 0;
    else scrollIndex = index;

    carousel.scrollTo({
      left: scrollIndex * itemWidth,
      behavior: 'smooth'
    });
  }

  // Arrow click → next card
  nextArrow.addEventListener('click', () => {
    scrollToIndex(scrollIndex + 1);
    resetAutoSlide();
  });

  // Auto-slide every 4 seconds
  // let autoSlide = setInterval(() => {
  //   scrollToIndex(scrollIndex + 1);
  // }, 4000);

  // Reset auto-slide on arrow click or swipe
  // function resetAutoSlide() {
  //   clearInterval(autoSlide);
  //   autoSlide = setInterval(() => {
  //     scrollToIndex(scrollIndex + 1);
  //   }, 4000);
  // }

  // Touch swipe support (mobile)
  // let startX = 0;
  // carousel.addEventListener('touchstart', e => startX = e.touches[0].clientX);
  // carousel.addEventListener('touchend', e => {
  //   const endX = e.changedTouches[0].clientX;
  //   if (endX - startX > 50) scrollToIndex(scrollIndex - 1); // swipe right
  //   else if (startX - endX > 50) scrollToIndex(scrollIndex + 1); // swipe left
  //   resetAutoSlide();
  // });

  // Update itemWidth on window resize
  window.addEventListener('resize', () => {
    itemWidth = carouselItems[0].offsetWidth + gap;
  });

});

// ---------------------------------------------order-tracking-card js------------------------------------------

/**
 * TMF Order Tracking Tab Switcher
 * Handles switching between Order Number and Tracking Number forms
 */
function tmfSwitchTab(type) {
  const orderFields = document.getElementById('tmfOrderFields');
  const trackingFields = document.getElementById('tmfTrackingFields');
  const orderTab = document.getElementById('orderTab');
  const trackingTab = document.getElementById('trackingTab');

  if (!orderFields || !trackingFields || !orderTab || !trackingTab) return;

  if (type === 'order') {
    // Show Order Number fields
    orderFields.classList.remove('tmf-tracking-hidden');
    trackingFields.classList.add('tmf-tracking-hidden');
    orderTab.classList.add('tmf-tracking-active');
    trackingTab.classList.remove('tmf-tracking-active');
  } else {
    // Show Tracking Number fields
    orderFields.classList.add('tmf-tracking-hidden');
    trackingFields.classList.remove('tmf-tracking-hidden');
    orderTab.classList.remove('tmf-tracking-active');
    trackingTab.classList.add('tmf-tracking-active');
  }
}
